import { create } from 'zustand';

type State = {
  paymentMethod: string,
}

type Action = {
  setPaymentMethod: (paymentMethod: string) => void,
  getPaymentMethod: () => string,
}

export const usePaymentMethodStore = create<State & Action>()((set, get) => ({
  paymentMethod: '',
  getPaymentMethod: () => get().paymentMethod,
  setPaymentMethod: (paymentMethod: string) => set(() => ({ paymentMethod })),
}));
